<template>
    <ToggleSimple @update:open="toggleOpen = $event">
        <template #toggle>
            <div class="left">
                <div v-if="$te(`fields.${name}.label`)" class="toggle-text">
                    {{ $t(`fields.${name}.label`) }}

                    <span v-if="isActive">
                        <div class="icon-check-dark"></div>
                    </span>
                </div>
                <div v-if="$te(`fields.${name}_alt.description`)" class="toggle-description">
                    {{ $t(`fields.${name}_alt.description`) }}
                </div>
            </div>
            <div class="right">
                <div v-if="isActive" class="reset" @click="resetSection">
                    <div class="icon-reset-pos"></div>
                </div>
                <div class="toggle-icon"></div>
            </div>
        </template>

        <template #content>
            <div :class="cssClassOptions">
                <CustomRangeSimple
                    inputKey="founded_alt"
                    :modelValue="founded"
                    :min="min"
                    :max="max"
                    :showLabel="false"
                    :showDescription="false"
                    :showLabelMinMax="true"
                    :formatLabelRange="false"
                    @update:modelValue="onRangeChanged"
                />
            </div>
        </template>
    </ToggleSimple>
</template>

<script>
    import debounce from 'lodash/debounce';
    import CustomRangeSimple from '@/components/elements/inputs/CustomRangeSimple';
    import ToggleSimple from '@/components/elements/misc/ToggleSimple';

    export default {
        name: "OptionsFounded",
        components: {
            ToggleSimple,
            CustomRangeSimple
        },
        props: {
            modelValue: {
                type: Object,
                default: () => ({ min: null, max: null })
            },
            defaultVal: {
                type: Object,
                default: () => ({ min: null, max: null })
            },
            showDescriptions: {
                type: Boolean,
                default: true
            },
            cssClassOptions: {
                type: String,
                default: 'options-type-4'
            }
        },
        data() {
            return {
                name: 'founded',
                toggleOpen: false,
                min: 0,
                max: new Date().getFullYear(),
                founded: {
                    min: this.modelValue.min !== null ? this.modelValue.min : '',
                    max: this.modelValue.max !== null ? this.modelValue.max : ''
                }
            };
        },
        computed: {
            isActive() {
                return this.modelValue.min > 0 || 
                       this.modelValue.max > 0;
            },
        },
        methods: {
            resetSection(event = null) {
                if (event) {
                    event.stopPropagation()
                }
                this.founded = { min: '', max: '' };
                this.$emit('update:modelValue', { min: null, max: null });
            },
            onRangeChanged(value) {
                var { min, max } = value;
                this.founded = { min, max };
                
                if ((min === '' || min < 1 || min < this.min) && (max === '' || max < 1 || max > this.max)) {
                    this.debouncedUpdate({ min: null, max: null });
                } else {
                    const newFounded = {
                        min: min === '' || min < 1 || min < this.min ? null : Number(min),
                        max: max === '' || max < 1 || max > this.max ? null : Number(max)
                    };
                    
                    this.debouncedUpdate(newFounded);
                }
            }
        },
        watch: {
            modelValue: {
                deep: true,
                handler(newVal) {
                    this.founded = {
                        min: newVal.min !== null ? newVal.min : '',
                        max: newVal.max !== null ? newVal.max : ''
                    };
                }
            }
        },
        mounted() {
            this.debouncedUpdate = debounce(function(founded) {
                this.$emit('update:modelValue', founded);
            }.bind(this), 300);
        }
    }
</script>